export default __webpack_public_path__ + "static/media/021-earrings.e374c31f.svg";